import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 0;
  top: 47px;
  width: 206px;
  box-shadow: 0 2px 50px 0 rgba(28, 34, 67, 0.1);
  background-color: ${({ theme }) => theme.backgrounds.actionDropDown};
  border-radius: 3px;
  z-index: 3;
  padding: 9px 9px 15px 10px;
  border: solid 1px ${({ theme }) => theme.borders.exportWrapper};
`;
Wrapper.displayName = 'Wrapper';

export const ExportButton = styled.button`
  height: 34px;
  width: 183px;
  margin: 0;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.borders.exportButton};
  color: ${({ theme }) => theme.text.actionBar};
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
`;
ExportButton.displayName = 'ExportButton';

export const WrapperField = styled.div`
  display: flex;
  align-items: center;
  margin-top: 13px;
`;
WrapperField.displayName = 'WrapperField';

export const Label = styled.div`
  margin-left: 4px;
  font-size: 11px;
  color: ${({ theme }) => theme.text.modalDescription};
  line-height: 2.82;
  font-weight: 400;
`;
Label.displayName = 'Label';
